import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms'; // <-- NgModel lives here
import { LayoutModule} from '@progress/kendo-angular-layout';
import { CKEditorModule } from 'ckeditor4-angular';

import { ReviewerComponent } from './reviewer.component';
import { EmailTreeComponent } from './email-tree/email-tree.component'
import { SpinnerModule } from '../../../common/component/spinner/spinner.module';
import { ConfirmDialogModule } from '../../../common/component/confirm-dialog/confirm-dialog.module';
import { SelectDlgModule } from './select-dlg/select-dlg.module';
import { AlertModule } from '../../../common/component/alert/alert.module';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,LayoutModule
    ,SpinnerModule
    ,ConfirmDialogModule
    ,CKEditorModule
    ,SelectDlgModule
    ,AlertModule
  ],
  declarations: [ReviewerComponent, EmailTreeComponent],
  exports: [ReviewerComponent
  , EmailTreeComponent
  ]
})
export class ReviewerModule { }
